export interface InteractiveChannel {
  id: string;
  provider: InteractiveChannelProvider;
  interactiveChannelId: string;
  hostId: string;
  topic: string;
  alternativeHosts: string[];
  startUrl: string;
  joinUrl: string;
  isActive: boolean;
  registeredUsers: RegisteredUser[];
  interactiveSessions: InteractiveSession[];
}

export enum InteractiveChannelProvider {
  Zoom = 1,
  Pexip = 2
}

export interface RegisteredUser {
  firstName: string;
  lastName: string;
  email: string;
  joinUrl: string;
}

export interface InteractiveSession {
  interactiveChannelId: string;
  uuid: string;
  start_time: string;
  end_time: string;
  duration: number;
  participants: InteractiveSessionParticipant[];
  visitReasons: string[] | null;
}

export interface InteractiveSessionParticipant {
  id: string;
  name: string;
  email: string;
}

export interface InteractiveSessionRequestResponse {
  success: boolean;
  errorMessage: string | null;
  interactiveChannel: InteractiveChannel;
}

export interface InteractiveSessionJoinRequestResponse {
  success: boolean;
  errorMessage: string;
  joinUrl: string;
}
